import { Apartment, Event, ContentPaste, IntegrationInstructions } from '@mui/icons-material';

import Routes from '@/router/Routes.ts';

export const adminNavbar = [
  {
    title: 'navbar.restaurants',
    path: Routes.ADMIN__RESTAURANTS,
    icon: <Apartment />,
  },
  {
    title: 'navbar.integrations',
    path: Routes.ADMIN__INTEGRATIONS,
    icon: <IntegrationInstructions />,
  },
  {
    title: 'navbar.faq',
    path: Routes.ADMIN__FAQ,
    icon: <ContentPaste />,
  },
];

export const managerNavbar = [
  {
    title: 'navbar.reservations',
    path: Routes.MANAGER__RESERVATIONS,
    icon: <Event />,
  },
];
